<template>
  <Training />
</template>

<script>
import Training from '@/components/content/education/training/TrainingMain.vue'

export default {
  name: 'TrainingPage',
  components: { Training }
}
</script>

<style scoped>

</style>
